import Container from 'app/components/common/Container';
import { createMarkup } from 'app/scripts/utils';

import CloudinaryImage from '../common/CloudinaryImage';
import LINK from '../common/LINK';

export default function SuccesfulTeams({ section }) {
  return (
    <Container className="md:pt-[75px] pt-[35px]">
      <h4 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight text-center max-w-[1000px] mx-auto lg:mb-[34px] mb-[30px]">
        {section?.h1_black} {section?.h1_purple}
      </h4>
      <div className="flex flex-col lg:flex-row md:justify-around items-center">
        <div className="succesful-team lg:basis-1/2 md:mb-[0px] mb-[2rem]">
          <ol className="relative border-l-2 border-lightGray">
            <li className="relative mb-8 pl-8">
              <div className="absolute w-3 h-3 bg-primary shadow-dotShadow rounded-full left-0 top-1.5 -translate-x-1/2 border border-white dark:border-gray-900 dark:bg-gray-700;"></div>
              <p className="font-bold mb-3 text-[18px]">{section?.title1}</p>
              <div
                className="text-sm"
                dangerouslySetInnerHTML={createMarkup(section?.body1)}
              ></div>
            </li>
            <li className="relative mb-8 pl-8">
              <div className="absolute w-3 h-3 bg-primary shadow-dotShadow rounded-full left-0 top-1.5 -translate-x-1/2  border border-white dark:border-gray-900 dark:bg-gray-700;"></div>
              <h3 className="font-bold mb-3 text-[18px]">{section?.title2}</h3>
              <div
                className="text-sm"
                dangerouslySetInnerHTML={createMarkup(section?.body2)}
              ></div>
            </li>
            <li className="relative mb-8 pl-8">
              <div className="absolute w-3 h-3 bg-primary shadow-dotShadow rounded-full left-0 -translate-x-1/2 top-1.5 border border-white dark:border-gray-900 dark:bg-gray-700;"></div>
              <p className="font-bold mb-3 text-[18px]">{section?.title3}</p>
              <div
                className="text-sm"
                dangerouslySetInnerHTML={createMarkup(section?.body3)}
              ></div>
            </li>
            <li className="relative flex mb-0 pl-8">
              <div className="text-[18px] font-[600] absolute w-3 h-3 bg-red-600 shadow-dotShadow rounded-full left-0 top-1.5 -translate-x-1/2 border border-white dark:border-gray-900 dark:bg-gray-700;"></div>
              <p>Have a question?</p>
              <div className="pl-4 mt-[-8px]">
                <LINK
                  m_top={'0px'}
                  reflink={`/about-us/contact-us/`}
                  py={'py-1'}
                  px={'px-3'}
                  bgColor={'#FFA030'}
                  textColor={'#000D3A'}
                  hoverBgColor={'#fff'}
                  HOVERTextColor={'#000D3A'}
                  borderColor={'#FFA030'}
                >
                  {section?.button_text}
                </LINK>
              </div>
            </li>
          </ol>
        </div>
        <div className="relative md:basis-1/3 h-fit">
          <div className="image-container">
            {section?.image?.data?.attributes?.url && (
              <CloudinaryImage
                backendImgUrl={section?.image?.data?.attributes?.url ?? '/'}
                className=" object-cover relative z-20 image !w-full"
                alt={section?.image.data.attributes.alternativeText}
                type="smallimg"
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
